<template>
  <div class="ObjectDetail" v-if="showObjectDetailCard.name">
    <div class="close" @click="close"></div>
    <img
      ondragstart="return false;"
      :src="
        clickBtnType == '关闭'
          ? showObjectDetailCard.communicationImagepath
          : showObjectDetailCard.Imagepath
      "
      alt=""
    />
    <template v-if="showObjectDetailCard.ObjectName.length">
      <div
        :class="
          clickBtnType == item.name && showObjectDetailCard.name !== '门禁设施'
            ? 'eventBtn active'
            : 'eventBtn'
        "
        v-for="(item, index) in showObjectDetailCard.ObjectName"
        :key="index"
        :style="{ top: item.top }"
        @click="triggerEvent(item, index)"
      >
        <div
          class="icon"
          v-if="
            clickBtnType == item.name &&
            showObjectDetailCard.name !== '门禁设施'
          "
        >
          <img
            ondragstart="return false;"
            :src="
              require(`../../assets/img/pageCard/ObjectDetails/icon/${item.iconNameAct}.png`)
            "
            alt=""
          />
        </div>
        <div
          class="text"
          v-if="
            clickBtnType == item.name &&
            showObjectDetailCard.name !== '门禁设施'
          "
        >
          {{ item.name }}
        </div>
      </div>
    </template>
    <div v-if="showObjectDetailCard.system">
      <div
        :class="
          clickBtnType == item.name
            ? 'JumpBusinessSystem JumpBusinessSystemActive'
            : 'JumpBusinessSystem'
        "
        v-for="(item, index) in showObjectDetailCard.system"
        :key="index"
        :style="{
          top: clickBtnType == '即时通讯' ? item.secondTop : item.top,
        }"
        @click="JumpBusinessSystem(item, index)"
      >
        <div class="icon" v-if="clickBtnType == item.name">
          <img
            ondragstart="return false;"
            :src="
              require(`../../assets/img/pageCard/ObjectDetails/icon/${item.iconNameAct}.png`)
            "
            alt=""
          />
        </div>
        <div class="text" v-if="clickBtnType == item.name">
          {{ item.name }}
        </div>
      </div>
    </div>

    <div
      class="video"
      v-if="showObjectDetailCard.name.indexOf('摄像头') !== -1"
    >
      <video
        v-if="highLight == '园区'"
        src="/video/车闸.mp4"
        autoplay
        loop
        muted
      ></video>
      <video v-else src="/video/综合安防01.mp4" autoplay loop muted></video>
    </div>
  </div>
</template>

<script>
import BaseDrawer from '../common/BaseDrawer.vue'
import UEapi from '../../utils/UEapi/UEapi'
import { mapState } from 'vuex'
export default {
  props: {
    currentPopup: {
      type: String,
      default: '1231231',
    },
  },
  computed: {
    ...mapState(['objectInfo', 'isOpenDoor', 'DoorStatus', 'highLight']),
  },
  components: {
    BaseDrawer,
  },
  data() {
    return {
      ObjectDetailList: {
        固定摄像头: {
          name: '摄像头',
          ObjectName: [
            { name: '工单派发', top: '1065px', iconNameAct: 'GDPF_ACT' },
            { name: '创建会议', top: '1135px', iconNameAct: 'CJHY_ACT' },
          ],
          Imagepath: require('../../assets/img/pageCard/ObjectDetails/PTSXT.png'),
          system: [],
        },
        云台摄像头: {
          name: '摄像头云台',
          ObjectName: [],
          Imagepath: require('../../assets/img/pageCard/ObjectDetails/SXTYT.png'),
          system: [],
        },
        人脸识别摄像头: {
          name: '摄像头人脸识别',
          ObjectName: [],
          Imagepath: require('../../assets/img/pageCard/ObjectDetails/SXTRLSB.png'),
          system: [
            { name: '跳转业务系统', top: '977px', iconNameAct: 'TZYWXT_ACT' },
          ],
        },
        门禁设施: {
          name: '门禁设施',
          ObjectName: [{ name: '打开', top: '573px', iconNameAct: 'GB_ACT' }],
          Imagepath: require('../../assets/img/pageCard/ObjectDetails/MJSS_DK.png'),
          communicationImagepath: require('../../assets/img/pageCard/ObjectDetails/MJSS.png'),
          system: [],
        },
        可燃气体探测器: {
          name: '可燃气体探测器',
          ObjectName: [],
          Imagepath: require('../../assets/img/pageCard/ObjectDetails/KRQTTCQ.png'),
          system: [],
        },
        消防烟感: {
          name: '消防烟感',
          ObjectName: [],
          Imagepath: require('../../assets/img/pageCard/ObjectDetails/XFYG.png'),
          system: [],
        },
        安保人员: {
          name: '安保人员',
          ObjectName: [],
          Imagepath: require('../../assets/img/pageCard/ObjectDetails/ABRY.png'),
          system: [
            { name: '跳转业务系统', top: '473px', iconNameAct: 'TZYWXT_ACT' },
          ],
        },
        巡检人员: {
          name: '巡检人员',
          ObjectName: [],
          Imagepath: require('../../assets/img/pageCard/ObjectDetails/XJRY.png'),
          system: [
            { name: '跳转业务系统', top: '473px', iconNameAct: 'TZYWXT_ACT' },
          ],
        },
        设备告警: {
          name: '设备告警',
          ObjectName: [
            { name: '工单派发', top: '575px', iconNameAct: 'GDPF_ACT' },
            { name: '创建会议', top: '645px', iconNameAct: 'CJHY_ACT' },
          ],
          Imagepath: require('../../assets/img/pageCard/ObjectDetails/SBGJ.png'),
          system: [],
        },
        火灾告警: {
          name: '火灾告警',
          ObjectName: [],
          Imagepath: require('../../assets/img/pageCard/ObjectDetails/HZGJ.png'),
          system: [],
        },
        水表设备: {
          name: '水表设备',
          ObjectName: [],
          Imagepath: require('../../assets/img/pageCard/ObjectDetails/SBSB.png'),
          system: [
            { name: '跳转业务系统', top: '1005px', iconNameAct: 'TZYWXT_ACT' },
          ],
        },
        电表设备: {
          name: '电表设备',
          ObjectName: [],
          Imagepath: require('../../assets/img/pageCard/ObjectDetails/DBSB.png'),
          system: [
            { name: '跳转业务系统', top: '955px', iconNameAct: 'TZYWXT_ACT' },
          ],
        },
        空调: {
          name: '空调',
          ObjectName: [],
          Imagepath: require('../../assets/img/pageCard/ObjectDetails/KT.png'),
          system: [
            { name: '跳转业务系统', top: '1162px', iconNameAct: 'TZYWXT_ACT' },
          ],
        },
        环境监测设备: {
          name: '环境监测设备',
          ObjectName: [],
          Imagepath: require('../../assets/img/pageCard/ObjectDetails/HJJCSB.png'),
          system: [
            { name: '跳转业务系统', top: '590px', iconNameAct: 'TZYWXT_ACT' },
          ],
        },
      },
      showObjectDetailCard: {},
      clickBtnType: '',
      isCommunication: false,
      second: '00',
      minute: '00',
      time: null,
      isOpen: false,
    }
  },
  methods: {
    triggerEvent(item, index) {
      let meetingData = []
      let count = 0
      switch (item.name) {
        case '创建会议':
          this.clickBtnType = item.name
          break
        case '工单派发':
          this.clickBtnType = item.name
          break
        case '跳转业务系统':
          this.clickBtnType = item.name
          break
        case '关闭':
          UEapi.Model.playAnimation({
            id: 'SM_IDC室内04',
            name:
              this.showObjectDetailCard.idObj == '1003'
                ? '大门A_关'
                : '大门B_关',
            state: 'begin',
          })
          this.$store.commit('setDoorStatus', {
            [this.showObjectDetailCard.idObj]: false,
          })
          this.showObjectDetailCard.ObjectName[0].name = '打开'
          this.clickBtnType = '打开'
          break
        case '打开':
          UEapi.Model.playAnimation({
            id: 'SM_IDC室内04',
            name:
              this.showObjectDetailCard.idObj == '1003'
                ? '大门A_开'
                : '大门B_开',
            state: 'begin',
          })
          this.$store.commit('setDoorStatus', {
            [this.showObjectDetailCard.idObj]: true,
          })
          this.showObjectDetailCard.ObjectName[0].name = '关闭'
          this.clickBtnType = '关闭'
          break
        default:
          break
      }
      this.$emit('triggerEvent', item)
    },

    JumpBusinessSystem(item, index) {
      this.clickBtnType = item.name
      this.$emit('triggerEvent', item)
    },
    close() {
      this.clickBtnType = ''
      this.showObjectDetailCard = {}
      this.ObjectDetailList[
        '门禁设施'
      ].Imagepath = require('../../assets/img/pageCard/ObjectDetails/MJSS_DK.png')
    },
  },
  mounted() {},
  watch: {
    objectInfo: {
      handler(val, oldVal) {
        if (val.showName) {
          if (val.idObj) {
            if (this.DoorStatus[val.idObj]) {
              this.clickBtnType = '关闭'
            } else {
              this.clickBtnType = '打开'
            }
          } else {
            this.clickBtnType = ''
          }
          let layerName = val.showName.split('-')[1]
          this.showObjectDetailCard = this.ObjectDetailList[layerName] ?? {}
          if (val.idObj) {
            if (val.idObj !== '1002' && val.idObj !== '1003') {
              this.showObjectDetailCard.Imagepath = require('../../assets/img/pageCard/ObjectDetails/MJSS_WCZ.png')
            }
            this.showObjectDetailCard.idObj = val.idObj
            this.showObjectDetailCard.ObjectName[0].name = this.DoorStatus[
              val.idObj
            ]
              ? '关闭'
              : '打开'
          }
        } else {
          this.showObjectDetailCard = {}
        }
      },
      deep: true,
    },

    currentPopup: {
      handler(val) {
        if (!val) {
          this.clickBtnType = ''
        }
      },
      deep: true,
    },
  },
}
</script>

<style lang="less" scoped>
.ObjectDetail {
  width: 680px;
  height: 1720px;
  position: relative;
  pointer-events: all;

  .video {
    position: absolute;
    top: 589px;
    left: 40px;
    width: 610px;
    height: 343px;

    & > video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .close {
    width: 24px;
    height: 24px;
    background: url('../../assets/img/SSGJ/close.png');
    position: absolute;
    top: 20px;
    right: 23px;
  }

  .eventBtn {
    position: absolute;
    width: 600px;
    height: 50px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
  }

  .active {
    width: 600px;
    height: 50px;
    background: #e9f9fe;
    color: #06a8dd;
    font-size: 28px;
    font-family: '微软雅黑';
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2px;

    .icon {
      width: 15px;
      height: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 10px;
    }

    .text {
      // height: 24px;
      margin-left: 2px;
    }
  }

  .JumpBusinessSystem {
    position: absolute;
    left: 434px;
    width: 220px;
    height: 50px;
  }

  .JumpBusinessSystemActive {
    width: 220px;
    height: 50px;
    background: #e9f9fe;
    color: #06a8dd;
    font-size: 24px;
    font-family: '微软雅黑';
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2px;

    .icon {
      width: 15px;
      height: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 2px;
    }

    .text {
      // height: 16px;
    }
  }

  .communication {
    position: absolute;
    top: 350px;
    left: 1px;
    width: 338px;
    height: 280px;
    background: rgba(43, 255, 255, 0.05);
    display: flex;
    flex-direction: column;
    align-items: center;

    .hint {
      position: relative;
      z-index: 9;
      width: 100%;
      margin-top: 10px;

      .await {
        width: 100%;
        text-align: center;
        color: #999999;
        font-size: 14px;
        font-family: '微软雅黑';
      }

      .duration {
        width: 100%;
        text-align: center;
        color: #f0f8ff;
        font-size: 14px;
        font-family: '微软雅黑';
      }
    }

    .headPortrait {
      margin-top: 20px;
      width: 100%;
      height: 96px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;

      & > div {
        color: #f0f8ff;
        font-size: 20px;
        font-family: '微软雅黑';
      }
    }

    .video {
      position: absolute;
      top: 0px;
      left: 1px;
      z-index: 2;
      width: 338px;
      height: 280px;

      & > video {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .operating {
      position: absolute;
      bottom: 15px;
      left: 50%;
      margin-left: -142px;
      z-index: 9;
      width: 284px;
      height: 79px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      & > li {
        width: 74px;
        height: 79px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;

        & > div {
          color: #f0f8ff;
          font-size: 28px;
          font-family: '微软雅黑';
        }
      }
    }
  }
}
</style>
